// @flow
// $FlowFixMe
import React from "react";
import type { Dispatch } from "redux";
import { get, noop } from "lodash";
import { connect } from "react-redux";
import TVGConf from "@tvg/conf";
import mediator from "@tvg/mediator";
import HeaderTemplate from "@fdr/atomic-ui/_templates/Header";
import { onTriggerDeposit } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import { isXSell } from "@tvg/sh-utils/mobileUtils";
import { events as AlchemerEvents } from "@urp/alchemer";

type Props = {
  title: string,
  logoMod: string,
  isLogged: boolean,
  isActionToolsShown: boolean,
  quickDepositUrl: string,
  onLogoClick: *,
  prevPath: string,
  dispatch: Dispatch<*>,
  userLogout: ?boolean,
  homeState: ?string
};

export const onLogoClick = (): void => {
  mediator.base.dispatch({
    type: "LOGO:HOME_NAVIGATION"
  });
  AlchemerEvents.fdrLogoTapped();
};

export const backButtonClick = (destinationUrl: string) => {
  mediator.base.dispatch({
    type: "PPM_GO_BACK",
    payload: {
      destinationUrl
    }
  });
  AlchemerEvents.backTapped();
};

export const Header = (props: Props) => {
  const headerProps = {
    title: props.title,
    logoMod: props.logoMod,
    isLogged: props.isLogged,
    onLogoClick,
    ...(!isXSell()
      ? {
          onQuickDeposit: onTriggerDeposit
        }
      : {}),
    isActionToolsShown: get(
      props,
      "isActionToolsShown",
      props.logoMod !== "navigation"
    ),
    brand: TVGConf().brand,
    prevPath: props.prevPath,
    onBackClick: () => {
      backButtonClick(`${get(window, "location.host")}${props.prevPath}`);
    },
    backgroundColor: get(props, "backgroundColor"),
    color: get(props, "color"),
    arrowColor: get(props, "arrowColor"),
    iconSize: get(props, "iconSize"),
    fontSize: get(props, "fontSize"),
    height: get(props, "height"),
    align: get(props, "align"),
    hasBottomBorder: get(props, "hasBottomBorder"),
    homeState: get(props, "homeState")
  };

  return <HeaderTemplate {...headerProps} />;
};

Header.defaultProps = {
  title: "",
  logoMod: "",
  isLogged: false,
  quickDepositUrl: "",
  onLogoClick: noop,
  prevPath: "",
  dispatch: noop,
  isActionToolsShown: false,
  userLogout: undefined,
  homeState: undefined
};

// $FlowFixMe
export default connect((store) => ({
  userLogout: get(store, "userData.userLogout", undefined),
  homeState: get(store, "userData.user.homeAddress.state")
}))(Header);
